export default {
  SET_VARIANTS: (state, data) => {
    state.variants = data;
  },
  SET_VARIANT: (state, data) => {
    state.variant = data;
  },
};
